/** Treats 1, true, "true", "True" as truthy; missing/false values as not IDP. */
export const isIdpLeague = (isIdp: unknown): boolean =>
  isIdp === true || isIdp === "true" || isIdp === "True" || isIdp === 1 || isIdp === "1";

export const isIdpFromCommonLeagueData = (commonLeagueData: unknown): boolean => {
  const data = commonLeagueData as {
    league_info?: { is_idp?: unknown; idp?: unknown };
    is_idp?: unknown;
    idp?: unknown;
  } | null | undefined;
  const idpValue = data?.league_info?.is_idp ?? data?.league_info?.idp ?? data?.is_idp ?? data?.idp;
  return isIdpLeague(idpValue);
};
